export default class HealthCareProviderProfile {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly providerType: string,
    public readonly sessionDetails: string,
    public readonly scheduleType: string,
    public readonly isMigrationFlowEnabled: string,
  ) {}
}
